import { gql } from "@apollo/client"

export const GET_TEACHER = gql`
  query getTeacher($id: String!, $orgRefScope: OrgRefScope!) {
    educator {
      get(id: $id, orgRefScope: $orgRefScope) {
        id
        firstName
        lastName
        email
        username
        title
        schoolId
        additionalSchoolIds
        districtId
      }
    }
  }
`
